export const CHANGE_SEARCH_TO_EMPTY = "CHANGE_SEARCH_TO_EMPTY";
export const CHANGE_SEARCH_TO_VALUE = "CHANGE_SEARCH_TO_VALUE";